// TOP LEVEL IMPORTS
import React from 'react';
import PropTypes from 'prop-types';
// ANTD
import Form from 'antd/lib/form';
import Button from 'components/common/Button';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import Input from 'antd/lib/input';
//
import { SketchPicker } from 'react-color';

const FormItem = Form.Item;

// This component only renders the Session form, all the logic must be handled
// in the parent component.
class SessionTypeForm extends React.Component {
  handleSubmit = evt => {
    const {
      onBeforeHook, onErrorHook, onSubmitHook, form,
    } = this.props;

    evt.preventDefault();

    // Run before logic if provided and return on error
    try {
      onBeforeHook();
    } catch (exc) {
      return; // return silently
    }

    form.validateFields((err, { title, color }) => {
      if (err) {
        // Pass event up to parent component
        onErrorHook(err);
      } else {
        let valuesToInsert = {
          title,
          color: color.hex,
        };
        // Pass lineItem values to parent component to handle submit functionality
        onSubmitHook(valuesToInsert);
        this.props.form.resetFields();
      }
    });
  };

  render() {
    const { form, btnLabel, initialValue } = this.props;
    const { getFieldDecorator } = form;

    let titleConfig = {
      initialValue: (initialValue && initialValue.title) || null,
      validateTrigger: 'onBlur',
      rules: [
        { required: true, message: 'Please input a Title!' },
        { max: 70, message: 'Must be no more than 70 characters!' },
      ],
    };

    let colorConfig = {
      initialValue: (initialValue && initialValue.color) || '#000',
      validateTrigger: 'onBlur',
      valuePropName: 'color',
      trigger: 'onChangeComplete',
    };

    return (
      <div className="form-container" style={{ minHeight: '380px', maxWidth: '400px' }}>
        <Form onSubmit={this.handleSubmit} style={{ width: '100%' }}>
          <Row gutter={15}>
            <Col xs={24}>
              <FormItem label="Title" hasFeedback>
                {getFieldDecorator('title', titleConfig)(<Input size="large" placeholder="title..." />)}
              </FormItem>
            </Col>
            <Col xs={24}>
              <FormItem label="Color" hasFeedback>
                {getFieldDecorator('color', colorConfig)(<SketchPicker />)}
              </FormItem>
            </Col>
          </Row>
          <Button
            htmlType="submit"
            disabled={this.props.loading}
            loading={this.props.loading}
            style={{ marginLeft: 8 }}
          >
            {btnLabel}
          </Button>
        </Form>
      </div>
    );
  }
}

SessionTypeForm.propTypes = {
  btnLabel: PropTypes.string,
  initialValue: PropTypes.shape({
    title: PropTypes.string,
    color: PropTypes.string,
  }),
  disabled: PropTypes.bool,
  hideClientInput: PropTypes.bool,
  onBeforeHook: PropTypes.func,
  onErrorHook: PropTypes.func,
  onSubmitHook: PropTypes.func,
  form: PropTypes.shape({
    getFieldDecorator: PropTypes.func.isRequired,
  }).isRequired,
};

SessionTypeForm.defaultProps = {
  btnLabel: 'SUBMIT',
  initialValue: null,
  disabled: false,
  hideClientInput: false,
  onBeforeHook: () => {},
  onErrorHook: () => {},
  onSubmitHook: () => {},
};

export default Form.create()(SessionTypeForm);



// WEBPACK FOOTER //
// ./src/components/forms/SessionTypeForm/index.js